import { Avatar, type Column, EmptyState, Pill, Table } from "@/components/common";
import { useMembers } from "@/hooks/useInvitations";
import type { Member } from "@/types/invitation";

/** Membros cujo grant cobre esta organização: escopo workspace (cobre tudo) ou
 * escopo organization incluindo este orgId. Read-only — a gestão fica na aba
 * Membros do workspace. Backend: GET /members exige `access_grants.write`. */
export function OrgMembersSection({
  workspaceId,
  organizationId,
}: {
  workspaceId: number;
  organizationId: number;
}) {
  const { data: members = [], isLoading } = useMembers(workspaceId);

  const covering = members.filter(
    (m) =>
      m.scope === "workspace" ||
      (m.scope === "organization" && m.organization_ids.includes(organizationId)),
  );

  const columns: Column<Member>[] = [
    {
      id: "user",
      header: "Membro",
      cell: (m) => (
        <div className="emp-table-name">
          <Avatar name={m.user_name ?? m.user_email_masked} size="md" />
          <div>
            <div className="razao">{m.user_name ?? "—"}</div>
            <div className="fantasia">{m.user_email_masked}</div>
          </div>
        </div>
      ),
    },
    { id: "role", header: "Papel", cell: (m) => <span className="td-small">{m.role_name}</span> },
    {
      id: "scope",
      header: "Acesso",
      cell: (m) => (
        <Pill tone={m.scope === "workspace" ? "ativa" : "pausada"}>
          {m.scope === "workspace" ? "Workspace inteiro" : "Esta organização"}
        </Pill>
      ),
    },
  ];

  return (
    <Table
      rows={covering}
      columns={columns}
      getKey={(m) => String(m.id)}
      empty={
        <EmptyState
          icon="users"
          title={isLoading ? "Carregando…" : "Nenhum membro com acesso"}
          description={
            isLoading ? undefined : "Convide ou edite acessos na aba Membros do workspace."
          }
        />
      }
    />
  );
}
